export const PLAYER_STATUS = {
  IDLE: 'idle',
  PAUSED: 'paused',
  PLAYING: 'playing',
} as const

export type PlayerStatus = typeof PLAYER_STATUS[keyof typeof PLAYER_STATUS]

export const READ_ALOUD_BUTTON_VARIANT = {
  ICON: 'icon',
  LISTEN: 'listen',
} as const

export type ReadAloudButtonVariant = typeof READ_ALOUD_BUTTON_VARIANT[keyof typeof READ_ALOUD_BUTTON_VARIANT]

export const PLAYBACK_RATES = [1, 0.8, 1.2]

export const CHUNK_GAP_MS = 500
export const SECTION_GAP_MS = 1500
